import type { PickedVideo } from '@/stores/voltrUploadTypes';

import type { VideoSource } from './videoSource';

/**
 * Web: slices of the picked File are read on demand, never the whole file.
 * The blob: URL is only a fallback for a pick that carried no File.
 */
export async function openVideo({ uri, file }: PickedVideo): Promise<VideoSource> {
  const blob = file ?? (await (await fetch(uri)).blob());
  return {
    size: blob.size,
    read: async (offset, length) => new Uint8Array(await blob.slice(offset, offset + length).arrayBuffer()),
    close: () => {},
  };
}
